
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { alert } from '../utils/comm';

const DataGridMUI = ({ columns
                    , data
                    , setBind
                    , pk = []   // 기본은 빈 배열
                    , onCellClick 
                    , onPositionChange    
                    , onCellChange 
                    , getRowClassName
}) => {

    const [internalRows, setInternalRows] = useState();
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const getRowPk = (row) => {
        if (!pk || pk.length === 0) return null;
        if (typeof pk === 'string') return row[pk];
        return pk.map(key => row[key]).join('__');
    };
    
    // onPositionChange Event
    const handleRowClick = (params) => {
        
        // const rowIndex = internalRows.findIndex(row => getRowPk(row) === getRowPk(params.row));
        const rowIndex = params.id;

        setSelectedRowIndex(rowIndex);
    
        if (onPositionChange) {
            onPositionChange(rowIndex, params.row);
        }
    };

    useEffect(() => {
        if (data) {
            const withIds = data.map((row, index) => ({
                ...row,
                index: index  // ✅ 이렇게 따로 index 저장
            }));
            setInternalRows(withIds);
        }
    }, [data]);

    const formattedColumns = columns.map(col => {
        if (col.type === 'index') {
            return {
                field: col.id,
                headerName: col.name,
                width: col.width || 80,
                filterable: false,
                sortable:false,
                cellClassName: 's-text-center',
                renderCell: (params) => {
                    // const rowIndex = internalRows.findIndex(row => row[pk] === params.row[pk]);
                    if (pk && pk.length > 0) {
                        const rowIndex = internalRows.findIndex(row => getRowPk(row) === getRowPk(params.row));
                        const index = rowIndex + 1;
                        return index;
                    } else {
                        const index = (typeof params.id === 'number' ? params.id : parseInt(params.id.split('__').pop(), 10));
                        return index + 1;
                    }
                }
            };
        }
        else if (col.type === 'button') {
            return {
                field: col.id,
                headerName: col.name,
                width: col.width || 100,
                sortable: false,
                renderCell: (params) => (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                        <Button className="n_btn delete_btn" onClick={() => onCellClick({
                            info: {
                                column: col.id,
                                rowIndex: internalRows.findIndex(row => row[pk] === params.id)
                            },
                            ...params
                            })}>
                            {col.label || col.name}
                        </Button>
                    </div>
                )
            };
        } 
        else 
            return {
                field: col.id,
                headerName: col.name,
                width: col.width || 150,
                editable: true,
                renderHeader: (params) => (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <span>{col.name}</span>
                        {col.required === true && (
                            <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                        )}
                    </div>
                ),
                cellClassName: (params) => {
                    const classList = [];
                    const isAbsReadOnly = col.absReadOnly === true || col.absReadOnly === 'true';
                    const isReadOnly = col.readOnly === true || col.readOnly === 'true';
                    const isNewRow = params.row?.status === 'new';
                    
                    if (isAbsReadOnly || (isReadOnly && !isNewRow)) {
                        classList.push('readOnlyCell');
                    }
                    
                    if (col.textAlign) classList.push(`s-text-${col.textAlign}`);
                    return classList.join(' ');
                },
            };
        });

    const handleCellClick = (params) => {
        if (onCellClick) {
        const rowIndex = internalRows.findIndex(row => getRowPk(row) === getRowPk(params.row));

        onCellClick({
            info: {
                columnId: params.field,
                rowIndex,
            },
        });
        }
    };    
    
    return (
        <div style={{ height: 600, width: '100%' }}>
            <DataGrid
                rows={internalRows}
                columns={formattedColumns}
                getRowId={(row) => {
                    if (pk && pk.length > 0) {
                        const pkPart = Array.isArray(pk) ? pk.map(key => row[key]).join('__') : row[pk];
                        if (pkPart != null && pkPart !== '') {
                        return pkPart;
                        }
                    }
                    return row.index; // ✅ pk 없으면 index를 id로 사용
                }}
                pageSize={10}
                rowsPerPageOptions={[10]}
                onCellClick={handleCellClick}
                onRowClick={handleRowClick}
                processRowUpdate={async (newRow, oldRow) => {
                    const rowIndex = internalRows.findIndex(row => row[pk] === oldRow[pk]);

                    // 변경된 키 찾기
                    const changedKey = Object.keys(newRow).find(
                        key => newRow[key] !== oldRow[key]
                    );
                
                    // pk 중복체크 
                    if (changedKey === pk) {
                        const newValue = newRow[pk];
                
                        const isDuplicate = internalRows.some(
                            (row, idx) =>
                                idx !== rowIndex && row[pk] === newValue
                        );
                
                        if (isDuplicate) {
                            await alert({body : '이미 존재하는 PK 입니다.'});
                            return oldRow;
                        }
                    }
                
                    // 정상 변경 반영
                    const updatedRows = [...internalRows];
                    updatedRows[rowIndex] = newRow;
                    setInternalRows(updatedRows);
                    if (setBind) setBind(updatedRows);
                
                    if (onCellChange && changedKey) {
                        onCellChange({
                            rowIndex,
                            columnId: changedKey,
                            oldValue: oldRow[changedKey],
                            newValue: newRow[changedKey],
                            updatedRow: newRow
                        });
                    }

                    return newRow;
                }}
                experimentalFeatures={{ newEditingApi: true }}
                sx={{
                    '& .MuiDataGrid-columnHeaderTitleContainer': {
                        justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        width: '100%',
                        textAlign: 'center',
                    },
                    }}
                getRowClassName={(params) => {
                    return getRowClassName ? getRowClassName(params) : '';
                }}
            ></DataGrid>
        </div>
    );
};

export default DataGridMUI;